import { EstimateStatusTypes, isEstimateNoLongerALiveOffer } from 'src/app/shared/enums/estimate/estimate.enum';

export interface EstimateExpiryDisplayDetail {
  ApprovedDate?: string | Date;
  EstimateExpiresDate?: string | Date;
}

export interface EstimateExpiryDisplay {
  label: string;
  date: string | Date;
}

/**
 * Past acceptance the pre-approval expiry reads as if the signed contract lapses, so show the
 * approval date. Null drops the whole row. Mirrored in ProjulV1Portal's copy of this file.
 */
export function getEstimateExpiryDisplay(
  detail: EstimateExpiryDisplayDetail | undefined,
  estimateAlias: string,
  status: EstimateStatusTypes | null | undefined
): EstimateExpiryDisplay | null {
  const isApproved = isEstimateNoLongerALiveOffer(status);
  const date = isApproved ? detail?.ApprovedDate : detail?.EstimateExpiresDate;
  if (!date) return null;
  return {
    label: isApproved ? 'Approved:' : `${estimateAlias} Expires:`,
    date
  };
}
